import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=2d66657c&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuModal.vue"
export default component.exports